export default "__VITE_ASSET__C3L9NVFw__"